import { useContext } from 'react';
import { FileInputContext } from '../contexts';
import { assertContext } from '../../../utils';
export const useFileInputContext = () => {
    const context = useContext(FileInputContext);
    return assertContext(context, 'useFileInputContext', 'FileInputContextProvider');
};
//# sourceMappingURL=useFileInputContext.js.map